export default __webpack_public_path__ + "static/media/orion-logo-dark.7e682dd2.png";